import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { ModExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/ModExpression";

export class ModExpressionEditor extends ExpressionRuleEditor<ModExpression> {
    render() {
        return (
            <ExpressionPiece>
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
                mod
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
